/*
 * @Author: FengXiao
 * @Date: 2020-07-01 22:08:41
 * @LastEditors: FengXiao
 * @LastEditTime: 2021-01-22 15:02:08
 */

import Vue from 'vue';
import Vuex from 'vuex';
import Cookies from 'js-cookie';
import requestApi from '@/service';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    fixedHeight: false,
    token: '',
    user: {},
    excludeRouters: '',
    vipInfo: {},
	vipType:'',
	international_show:false,
  },
  mutations: {
    showSearch(state, value) {
      state.fixedHeight = value;
    },
    setToken(state, value) {
      state.token = value;
      Cookies.set('token', value);
      localStorage.token = value;
    },
    setUser(state, data) {
      state.user = data;
      localStorage.user = JSON.stringify(data);
    },
    setExcludeRouters(state, str) {
      state.excludeRouters = str;
    },
    setVipInfo(state, data) {
      if (data.end_time) {
        data.end_time = data.end_time.replace(/\//g, '-');
      }
      state.vipInfo = data;
    },
	setVipType(state, data) {
	  state.vipType = data.user.buy_type;
	},
	setInternational_show(state, value) {
		state.international_show = value;
	},
  },
  actions: {
    getVipInfo(content) {
      requestApi('/v3/api/h5/member/info/').then(res => {
        if (res.status) {
          content.commit('setVipInfo', res);
        }else {
			content.commit('setVipInfo', '');
		}
      });
	  requestApi('/v3/api/v1/user/').then(res => {
	  	  content.commit('setVipType', res);
	  });
    },
  },
  modules: {},
});
